export const environment = {
  production: false,
  erpBaseUrl: 'https://erp.staging.imt.fi',
  // Internal-staff deep links into the ERP UI (customer record editing from the
  // passenger-info customer search). Never shown to customers.
  erpFrontendUrl: 'https://erp.staging.imt.fi/ui',
  webshopBaseUrl: 'https://www.staging.imt.fi',
  // Same single entry as production: staging's sites are all `*.staging.imt.fi`,
  // which is already a subdomain of `imt.fi`. See `environment.prod.ts` for what
  // this gates.
  returnDomains: ['imt.fi'],
  wordpressApiUrl: 'https://www.staging.imt.fi/wp-json/wp/v2',
  // Browser Maps JS API key, restricted by HTTP referrer to `*.imt.fi/*` — which
  // covers varaus.staging.imt.fi. Public by nature: the referrer and API
  // restrictions are the control, not secrecy, so it lives here alongside the
  // Sentry DSN rather than in SSM. Both values are required — Advanced Markers
  // (the price pins) cannot load without a Map ID.
  maps: {
    apiKey: 'AIzaSyDU3E9NwljiSZ49BmT8tsWJ2qI6upFIJ1M',
    mapId: 'a709121d735d7b17fb24b0f5',
  },
  analytics: {
    // Same container as production, pinned to its staging environment so a staging deploy cannot
    // publish test tags to live traffic. See `environment.prod.ts`.
    enabled: true,
    gtmContainerId: 'GTM-M4HSJN5',
    gtmAuth: 'QZxOF3TTE0ZvGjohi-rV7g',
    gtmPreview: 'env-5',
  },
  sentry: {
    enabled: true,
    dsn: 'https://2dd64c41aa5acb403e873e2b9b6bca30@o4511189720563712.ingest.de.sentry.io/4511353886670928',
    environment: 'staging',
  },
};
